export const applyWooCartUpdates = (data: {
    fragments?: Record<string, unknown>;
    cart_hash?: string;
    cart_count?: number;
}): void => {
    const jqueryInstance = (window as any).jQuery;
    if (!jqueryInstance) {
        return;
    }

    const $ = jqueryInstance;
    const fragments = data && typeof data.fragments === 'object' && data.fragments !== null
        ? data.fragments
        : {};

    $.each(fragments, (key: string, value: unknown) => {
        $(key).replaceWith(value);
    });

    if (typeof data?.cart_count !== 'undefined') {
        $('.cart-contents-count, .cart-count').text(data.cart_count);
        $('.cart-badge, .cart-items-count').text(data.cart_count);
    }

    $(document.body).trigger('added_to_cart', [fragments, data?.cart_hash || '', $('<button type="button" />')]);
    $(document.body).trigger('wc_fragment_refresh');
};
